<template>
  <nav-tooltip :disabled="!collapsed">
    <template #activator="{ attrs, on }">
      <v-list-item
        link
        exact
        class="nav-item px-3 mb-2"
        :class="classes"
        :to="to"
        :data-cy="cypressId"
        v-bind="attrs"
        v-on="on"
      >
        <v-list-item-action :class="actionClasses">
          <v-icon class="material-icons-outlined">{{ icon }}</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title class="subtitle-1 font-weight-medium">
            {{ title }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>
    {{ title }}
  </nav-tooltip>
</template>

<script>
import NavTooltip from '@/components/AppBar/NavTooltip';

export default {
  name: 'NavItem',
  components: {
    NavTooltip,
  },
  props: {
    collapsed: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: 'home',
    },
    title: {
      type: String,
      default: 'Reviews',
    },
    to: {
      type: String,
      default: '/reviews',
    },
    cypressId: {
      type: String,
      default: null,
    },
  },
  computed: {
    classes() {
      return { 'fill-width': !this.collapsed };
    },
    actionClasses() {
      return { 'mr-5': !this.collapsed };
    },
  },
};
</script>

<style>
.fill-width {
  width: 100%;
}
.v-list--nav .nav-item:before {
  z-index: -1;
  background-color: #6779a5;
  border-radius: 8px !important;
}
.v-list--nav .nav-item.v-list-item:hover:before {
  opacity: 0.6;
}
.v-list--nav .nav-item.v-list-item--active:before {
  background-color: #6779a5;
  opacity: 1;
}
.nav-item .v-ripple__container {
  z-index: -1;
  background-color: #6779a5;
  border-radius: 8px !important;
  opacity: 0.3;
}
</style>
